"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeGroup = exports.BadgeType = exports.NumberedBadgeTheme = exports.BadgeTheme = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var popover_1 = require("../../components/popover");
var BadgeTheme;
(function (BadgeTheme) {
    BadgeTheme["ATTENTION"] = "attention";
    BadgeTheme["BRAND"] = "brand";
    BadgeTheme["ERROR"] = "error";
    BadgeTheme["FEATURED"] = "featured";
    BadgeTheme["INFO"] = "info";
    BadgeTheme["NEUTRAL"] = "neutral";
    BadgeTheme["SECONDARY"] = "secondary";
    BadgeTheme["SUCCESS"] = "success";
    BadgeTheme["UTILITY"] = "utility";
    BadgeTheme["VIP"] = "vip";
    BadgeTheme["VMC"] = "vmc";
})(BadgeTheme = exports.BadgeTheme || (exports.BadgeTheme = {}));
var NumberedBadgeTheme;
(function (NumberedBadgeTheme) {
    NumberedBadgeTheme["NUMBERED"] = "numbered";
    NumberedBadgeTheme["NUMBERED_PRIMARY"] = "numbered-primary";
    NumberedBadgeTheme["NUMBERED_SECONDARY"] = "numbered-secondary";
    NumberedBadgeTheme["NUMBERED_ACTION"] = "numbered-action";
    NumberedBadgeTheme["NUMBERED_REVERSED"] = "numbered-reversed";
    NumberedBadgeTheme["NUMBERED_VMC"] = "numbered-vmc";
})(NumberedBadgeTheme = exports.NumberedBadgeTheme || (exports.NumberedBadgeTheme = {}));
var BadgeType;
(function (BadgeType) {
    BadgeType["SMALL"] = "small";
    BadgeType["LARGE"] = "large";
})(BadgeType = exports.BadgeType || (exports.BadgeType = {}));
var Badge = function (props) {
    var description = props.description, classes = props.classes, text = props.text, theme = props.theme, type = props.type, numbered = props.numbered, otherProps = __rest(props, ["description", "classes", "text", "theme", "type", "numbered"]);
    switch (theme) {
        case BadgeTheme.SECONDARY:
            DeprecationUtils_1.logDeprecatedPropValue({
                component: 'Badge',
                propName: 'theme',
                versionStart: '1.4.2',
                versionEnd: '2.0.0',
                seeMsg: 'The SECONDARY and UTILITY themes will be removed in version 2.0.0'
            });
            break;
        case BadgeTheme.UTILITY:
            DeprecationUtils_1.logDeprecatedPropValue({
                component: 'Badge',
                propName: 'theme',
                versionStart: '1.4.2',
                versionEnd: '2.0.0',
                seeMsg: 'The SECONDARY and UTILITY themes will be removed in version 2.0.0'
            });
            break;
    }
    return react_1.default.createElement("span", __assign({ className: getClassNames(classes, theme, type, numbered, description) }, otherProps), getContent(text, description));
};
Badge.defaultProps = {
    type: BadgeType.SMALL,
    theme: BadgeTheme.NEUTRAL
};
var getClassNames = function (classes, theme, type, numbered, description) {
    var _a;
    return classnames_1.default('fds-badge', 'badge-inline', (_a = {},
        _a["badge-" + (type && type.trim().toLowerCase())] = type,
        _a["badge-" + (theme && theme.trim().toLowerCase())] = theme,
        _a['badge-described'] = description,
        _a['badge-numbered-notification'] = numbered,
        _a), classes);
};
var getContent = function (text, description) {
    return (description ? (react_1.default.createElement(popover_1.Popover, { label: text },
        description.heading && react_1.default.createElement(popover_1.PopoverHeading, null, description.heading),
        react_1.default.createElement(popover_1.PopoverBody, null, description.body))) : text);
};
var BadgeGroup = function (_a) {
    var children = _a.children, classes = _a.classes, otherProps = __rest(_a, ["children", "classes"]);
    return (react_1.default.createElement("div", __assign({}, otherProps, { className: classnames_1.default('fds-badge-group', classes) }), children));
};
exports.BadgeGroup = BadgeGroup;
exports.default = Badge;
